import options from './options';
const { hm, hma, hms, hmsa, ymd, ymdMed, ymdLong, ymdFull } = options;
export const Presets = {
    DATE_SHORT: ymd,
    DATE_MEDIUM: ymdMed,
    DATE_LONG: ymdLong,
    DATE_FULL: ymdFull,
    TIME: hma,
    TIME_WITH_SECONDS: hmsa,
    // @ts-ignore
    TIME_LONG: Object.assign(Object.assign({}, hmsa), { fractionalSecondDigits: 3 }),
    TIME_24: Object.assign(Object.assign({}, hm), { hour12: false }),
    TIME_24_WITH_SECONDS: Object.assign(Object.assign({}, hmsa), { hour12: false }),
    // @ts-ignore
    TIME_24_LONG: Object.assign(Object.assign({}, hms), { fractionalSecondDigits: 3, hour12: false }),
    DATETIME_SHORT: Object.assign(Object.assign({}, ymd), hm),
    DATETIME_SHORT_WITH_SECONDS: Object.assign(Object.assign({}, ymd), hms),
    DATETIME_MEDIUM: Object.assign(Object.assign({}, ymdMed), hm),
    DATETIME_MEDIUM_WITH_SECONDS: Object.assign(Object.assign({}, ymdMed), hms),
    DATETIME_LONG: Object.assign(Object.assign({}, ymdLong), hm),
    DATETIME_LONG_WITH_SECONDS: Object.assign(Object.assign({}, ymdLong), hms),
    DATETIME_FULL: Object.assign(Object.assign({}, ymdFull), hm),
    DATETIME_FULL_WITH_SECONDS: Object.assign(Object.assign({}, ymdFull), hms)
};
